export default "__VITE_ASSET__Ds0f0iXY__"